<div class="panel-header">
  <div class="header-top-row">
    <div class="tabs">
      <button class="tab" [class.active]="activeTab() === 'monitor'" (click)="setTab('monitor')">
        <mat-icon>wifi</mat-icon>
        <span>Monitor</span>
        @if (monitor.currentSession().entries.length > 0) {
          <span class="badge">{{ monitor.currentSession().entries.length }}</span>
        }
      </button>
      <button class="tab" [class.active]="activeTab() === 'saved'" (click)="setTab('saved')">
        <mat-icon>star</mat-icon>
        <span>Saved</span>
        @if (monitor.favorites().length > 0) {
          <span class="badge">{{ monitor.favorites().length }}</span>
        }
      </button>
      <button class="tab" [class.active]="activeTab() === 'mocks'" (click)="setTab('mocks')">
        <mat-icon>science</mat-icon>
        <span>Mocks</span>
        @if (monitor.mocks().length > 0) {
          <span class="badge" [class.badge-active]="monitor.mocks().some(m => m.enabled)">{{ monitor.mocks().length }}</span>
        }
      </button>
    </div>

    <div class="header-actions">
      @if (activeTab() === 'monitor') {
        @if (activeMockCount() > 0) {
          <span class="active-mocks-badge" title="Active mock rules">
            <mat-icon>science</mat-icon>
            {{ activeMockCount() }}
          </span>
        }
        @if (!consoleActive()) {
          <div class="inline-filters">
            <div class="filter-dropdown-wrapper">
              <button class="filter-dropdown-btn" (click)="toggleMethodDropdown($event)"
                      [class.has-filter]="!allMethodsEnabled()">
                <mat-icon>http</mat-icon>
                <span>{{ methodFilterLabel() }}</span>
                <mat-icon class="dropdown-arrow">{{ methodDropdownOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
              @if (methodDropdownOpen()) {
                <div class="filter-dropdown-menu" (click)="onDropdownClick($event)">
                  <label class="filter-dropdown-item toggle-all">
                    <input type="checkbox" [checked]="allMethodsEnabled()" (change)="toggleAllMethods()" />
                    <span>Select all</span>
                  </label>
                  <div class="filter-dropdown-sep"></div>
                  @for (m of methods; track m) {
                    <label class="filter-dropdown-item" [attr.data-method]="m">
                      <input type="checkbox" [checked]="isMethodEnabled(m)" (change)="toggleMethod(m)" />
                      <span class="method-label" [attr.data-method]="m">{{ m }}</span>
                    </label>
                  }
                </div>
              }
            </div>
            <div class="filter-dropdown-wrapper">
              <button class="filter-dropdown-btn" (click)="toggleStateDropdown($event)"
                      [class.has-filter]="!allStatesEnabled()">
                <mat-icon>filter_list</mat-icon>
                <span>{{ stateFilterLabel() }}</span>
                <mat-icon class="dropdown-arrow">{{ stateDropdownOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
              @if (stateDropdownOpen()) {
                <div class="filter-dropdown-menu" (click)="onDropdownClick($event)">
                  <label class="filter-dropdown-item toggle-all">
                    <input type="checkbox" [checked]="allStatesEnabled()" (change)="toggleAllStates()" />
                    <span>Select all</span>
                  </label>
                  <div class="filter-dropdown-sep"></div>
                  @for (s of states; track s) {
                    <label class="filter-dropdown-item" [attr.data-state]="s">
                      <input type="checkbox" [checked]="isStateEnabled(s)" (change)="toggleState(s)" />
                      <span class="state-dot" [attr.data-state]="s"></span>
                      <span>{{ stateLabel(s) }}</span>
                    </label>
                  }
                </div>
              }
            </div>
            <input class="search-input" type="text" placeholder="Filter path..."
                   [value]="searchQuery()"
                   (input)="onSearchChange($any($event.target).value)" />
          </div>
        } @else {
          <button class="header-btn" [class.active]="filtersVisible()" [class.has-active-filters]="hasActiveFilters()"
                  (click)="filtersVisible.set(!filtersVisible())" title="Toggle filters">
            <mat-icon>tune</mat-icon>
          </button>
        }
        <button class="header-btn" (click)="importSession()" title="Import session from JSON">
          <mat-icon>file_upload</mat-icon>
        </button>
        <button class="header-btn" (click)="exportSession()" title="Export session as JSON">
          <mat-icon>file_download</mat-icon>
        </button>
        <button class="header-btn" (click)="clearCurrent()" title="Clear (keep pinned)">
          <mat-icon>delete_sweep</mat-icon>
        </button>
      }
      @if (activeTab() === 'saved') {
        @if (!consoleActive()) {
          <div class="inline-filters">
            <div class="filter-dropdown-wrapper">
              <button class="filter-dropdown-btn" (click)="toggleMethodDropdown($event)"
                      [class.has-filter]="!allMethodsEnabled()">
                <mat-icon>http</mat-icon>
                <span>{{ methodFilterLabel() }}</span>
                <mat-icon class="dropdown-arrow">{{ methodDropdownOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
              @if (methodDropdownOpen()) {
                <div class="filter-dropdown-menu" (click)="onDropdownClick($event)">
                  <label class="filter-dropdown-item toggle-all">
                    <input type="checkbox" [checked]="allMethodsEnabled()" (change)="toggleAllMethods()" />
                    <span>Select all</span>
                  </label>
                  <div class="filter-dropdown-sep"></div>
                  @for (m of methods; track m) {
                    <label class="filter-dropdown-item" [attr.data-method]="m">
                      <input type="checkbox" [checked]="isMethodEnabled(m)" (change)="toggleMethod(m)" />
                      <span class="method-label" [attr.data-method]="m">{{ m }}</span>
                    </label>
                  }
                </div>
              }
            </div>
            <div class="filter-dropdown-wrapper">
              <button class="filter-dropdown-btn" (click)="toggleStateDropdown($event)"
                      [class.has-filter]="!allStatesEnabled()">
                <mat-icon>filter_list</mat-icon>
                <span>{{ stateFilterLabel() }}</span>
                <mat-icon class="dropdown-arrow">{{ stateDropdownOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
              @if (stateDropdownOpen()) {
                <div class="filter-dropdown-menu" (click)="onDropdownClick($event)">
                  <label class="filter-dropdown-item toggle-all">
                    <input type="checkbox" [checked]="allStatesEnabled()" (change)="toggleAllStates()" />
                    <span>Select all</span>
                  </label>
                  <div class="filter-dropdown-sep"></div>
                  @for (s of states; track s) {
                    <label class="filter-dropdown-item" [attr.data-state]="s">
                      <input type="checkbox" [checked]="isStateEnabled(s)" (change)="toggleState(s)" />
                      <span class="state-dot" [attr.data-state]="s"></span>
                      <span>{{ stateLabel(s) }}</span>
                    </label>
                  }
                </div>
              }
            </div>
            <input class="search-input" type="text" placeholder="Search saved..."
                   [value]="savedSearchQuery()"
                   (input)="savedSearchQuery.set($any($event.target).value)" />
          </div>
        } @else {
          <button class="header-btn" [class.active]="filtersVisible()" [class.has-active-filters]="hasActiveSavedFilters()"
                  (click)="filtersVisible.set(!filtersVisible())" title="Toggle filters">
            <mat-icon>tune</mat-icon>
          </button>
        }
        <button class="header-btn" (click)="importFavorites()" title="Import saved requests">
          <mat-icon>file_upload</mat-icon>
        </button>
        <button class="header-btn" (click)="exportFavorites()" title="Export saved requests"
                [disabled]="monitor.favorites().length === 0">
          <mat-icon>file_download</mat-icon>
        </button>
      }
      @if (activeTab() === 'mocks') {
        <button class="header-btn" (click)="bulkToggleMocks()" title="Toggle all mocks">
          <mat-icon>{{ monitor.mocks().some(m => m.enabled) ? 'toggle_on' : 'toggle_off' }}</mat-icon>
        </button>
        <button class="header-btn" (click)="importMocks()" title="Import mock rules">
          <mat-icon>file_upload</mat-icon>
        </button>
        <button class="header-btn" (click)="exportMocks()" title="Export mock rules"
                [disabled]="monitor.mocks().length === 0">
          <mat-icon>file_download</mat-icon>
        </button>
        <button class="header-btn" (click)="addMock()" title="Add new mock rule">
          <mat-icon>add</mat-icon>
        </button>
      }
    </div>
  </div>

  @if (activeTab() === 'monitor' && consoleActive() && filtersVisible()) {
    <div class="filter-row">
      <div class="filters">
        <div class="filter-dropdown-wrapper">
          <button class="filter-dropdown-btn" (click)="toggleMethodDropdown($event)"
                  [class.has-filter]="!allMethodsEnabled()">
            <mat-icon>http</mat-icon>
            <span>{{ methodFilterLabel() }}</span>
            <mat-icon class="dropdown-arrow">{{ methodDropdownOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          @if (methodDropdownOpen()) {
            <div class="filter-dropdown-menu" (click)="onDropdownClick($event)">
              <label class="filter-dropdown-item toggle-all">
                <input type="checkbox" [checked]="allMethodsEnabled()" (change)="toggleAllMethods()" />
                <span>Select all</span>
              </label>
              <div class="filter-dropdown-sep"></div>
              @for (m of methods; track m) {
                <label class="filter-dropdown-item" [attr.data-method]="m">
                  <input type="checkbox" [checked]="isMethodEnabled(m)" (change)="toggleMethod(m)" />
                  <span class="method-label" [attr.data-method]="m">{{ m }}</span>
                </label>
              }
            </div>
          }
        </div>

        <div class="filter-dropdown-wrapper">
          <button class="filter-dropdown-btn" (click)="toggleStateDropdown($event)"
                  [class.has-filter]="!allStatesEnabled()">
            <mat-icon>filter_list</mat-icon>
            <span>{{ stateFilterLabel() }}</span>
            <mat-icon class="dropdown-arrow">{{ stateDropdownOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          @if (stateDropdownOpen()) {
            <div class="filter-dropdown-menu" (click)="onDropdownClick($event)">
              <label class="filter-dropdown-item toggle-all">
                <input type="checkbox" [checked]="allStatesEnabled()" (change)="toggleAllStates()" />
                <span>Select all</span>
              </label>
              <div class="filter-dropdown-sep"></div>
              @for (s of states; track s) {
                <label class="filter-dropdown-item" [attr.data-state]="s">
                  <input type="checkbox" [checked]="isStateEnabled(s)" (change)="toggleState(s)" />
                  <span class="state-dot" [attr.data-state]="s"></span>
                  <span>{{ stateLabel(s) }}</span>
                </label>
              }
            </div>
          }
        </div>
      </div>

      <input class="search-input" type="text" placeholder="Filter path..."
             [value]="searchQuery()"
             (input)="onSearchChange($any($event.target).value)" />
    </div>
  }

  @if (activeTab() === 'saved' && consoleActive() && filtersVisible()) {
    <div class="filter-row">
      <div class="filters">
        <div class="filter-dropdown-wrapper">
          <button class="filter-dropdown-btn" (click)="toggleMethodDropdown($event)"
                  [class.has-filter]="!allMethodsEnabled()">
            <mat-icon>http</mat-icon>
            <span>{{ methodFilterLabel() }}</span>
            <mat-icon class="dropdown-arrow">{{ methodDropdownOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          @if (methodDropdownOpen()) {
            <div class="filter-dropdown-menu" (click)="onDropdownClick($event)">
              <label class="filter-dropdown-item toggle-all">
                <input type="checkbox" [checked]="allMethodsEnabled()" (change)="toggleAllMethods()" />
                <span>Select all</span>
              </label>
              <div class="filter-dropdown-sep"></div>
              @for (m of methods; track m) {
                <label class="filter-dropdown-item" [attr.data-method]="m">
                  <input type="checkbox" [checked]="isMethodEnabled(m)" (change)="toggleMethod(m)" />
                  <span class="method-label" [attr.data-method]="m">{{ m }}</span>
                </label>
              }
            </div>
          }
        </div>

        <div class="filter-dropdown-wrapper">
          <button class="filter-dropdown-btn" (click)="toggleStateDropdown($event)"
                  [class.has-filter]="!allStatesEnabled()">
            <mat-icon>filter_list</mat-icon>
            <span>{{ stateFilterLabel() }}</span>
            <mat-icon class="dropdown-arrow">{{ stateDropdownOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          @if (stateDropdownOpen()) {
            <div class="filter-dropdown-menu" (click)="onDropdownClick($event)">
              <label class="filter-dropdown-item toggle-all">
                <input type="checkbox" [checked]="allStatesEnabled()" (change)="toggleAllStates()" />
                <span>Select all</span>
              </label>
              <div class="filter-dropdown-sep"></div>
              @for (s of states; track s) {
                <label class="filter-dropdown-item" [attr.data-state]="s">
                  <input type="checkbox" [checked]="isStateEnabled(s)" (change)="toggleState(s)" />
                  <span class="state-dot" [attr.data-state]="s"></span>
                  <span>{{ stateLabel(s) }}</span>
                </label>
              }
            </div>
          }
        </div>
      </div>

      <input class="search-input" type="text" placeholder="Search saved..."
             [value]="savedSearchQuery()"
             (input)="savedSearchQuery.set($any($event.target).value)" />
    </div>
  }
</div>

<div class="panel-body" #panelBody>
  @if (activeTab() === 'monitor') {
    @if (allPinnedEntries().length > 0) {
      <div class="session-header pinned-header">
        <mat-icon class="pinned-header-icon">push_pin</mat-icon>
        Pinned
      </div>
      @for (entry of filterEntries(allPinnedEntries()); track entry.id) {
        <app-network-row
          [entry]="entry"
          (relaunch)="relaunch($event)"
          (saveFavorite)="saveFavorite($event)"
          (createMock)="createMockFromEntry($event)"
          (copyToken)="copyToken()"
          (pin)="togglePin($event)" />
      }
    }

    @if (monitor.hasMoreHistory()) {
      <button class="load-history-row" (click)="loadOneMoreSession()">
        <mat-icon>history</mat-icon>
        <span>Cargar sesión anterior</span>
      </button>
    }

    @for (session of monitor.loadedHistory(); track session.id) {
      <div class="session-header historic">
        &mdash; Sesión {{ formatSessionDate(session.startedAt) }} &mdash;
      </div>
      @for (entry of filterUnpinnedEntries(session.entries); track entry.id) {
        <app-network-row
          [entry]="entry"
          (relaunch)="relaunch($event)"
          (saveFavorite)="saveFavorite($event)"
          (createMock)="createMockFromEntry($event)"
          (copyToken)="copyToken()"
          (pin)="togglePin($event)"
          (delete)="deleteHistoricEntry(session.id, $event)" />
      }
    }

    <div class="session-header">
      &mdash; Sesión actual ({{ formatSessionDate(monitor.currentSession().startedAt) }}) &mdash;
    </div>
    @if (monitor.currentSession().entries.length === 0) {
      <div class="empty">No requests captured yet</div>
    }
    @for (entry of filterUnpinnedEntries(monitor.currentSession().entries); track entry.id) {
      <app-network-row
        [entry]="entry"
        (relaunch)="relaunch($event)"
        (saveFavorite)="saveFavorite($event)"
        (createMock)="createMockFromEntry($event)"
        (copyToken)="copyToken()"
        (pin)="togglePin($event)"
        (delete)="deleteCurrentEntry($event)" />
    }
  }

  @if (activeTab() === 'saved') {
    @if (monitor.favorites().length === 0) {
      <div class="empty">
        No saved requests yet
        <button class="empty-action" (click)="setTab('monitor')">Go to Monitor to save one</button>
      </div>
    } @else if (groupedFavorites().length === 0 && savedSearchQuery()) {
      <div class="empty">No results for "{{ savedSearchQuery() }}"</div>
    }
    @for (group of groupedFavorites(); track group.folder) {
      @if (group.folder) {
        <div class="folder-header" (click)="toggleFolder(group.folder)">
          <mat-icon class="folder-arrow">{{ isFolderExpanded(group.folder) ? 'expand_more' : 'chevron_right' }}</mat-icon>
          <mat-icon class="folder-icon">folder</mat-icon>
          <span class="folder-name">{{ group.folder }}</span>
          <span class="folder-count">{{ group.items.length }}</span>
          <span class="folder-actions">
            <button class="header-btn" (click)="runFolder(group.folder, $event)" title="Run all in folder">
              <mat-icon>play_arrow</mat-icon>
            </button>
            <button class="header-btn" (click)="runFolderSequential(group.folder, $event)" title="Run all sequentially">
              <mat-icon>playlist_play</mat-icon>
            </button>
          </span>
        </div>
        @if (isFolderExpanded(group.folder)) {
          @for (fav of group.items; track fav.id) {
            <app-network-saved-row
              [entry]="fav"
              (relaunch)="relaunchSaved($event)"
              (duplicate)="duplicateFavorite($event)"
              (delete)="deleteFavorite($event)"
              (dragReorder)="onDragReorder($event)" />
          }
        }
      } @else {
        @for (fav of group.items; track fav.id) {
          <app-network-saved-row
            [entry]="fav"
            (relaunch)="relaunchSaved($event)"
            (duplicate)="duplicateFavorite($event)"
            (delete)="deleteFavorite($event)"
            (dragReorder)="onDragReorder($event)" />
        }
      }
    }
  }

  @if (activeTab() === 'mocks') {
    @if (monitor.mocks().length === 0) {
      <div class="empty">
        No mock rules yet
        <button class="empty-action" (click)="addMock()">Create one</button>
      </div>
    }
    @for (group of groupedMocks(); track group.folder) {
      @if (group.folder) {
        <div class="folder-header" (click)="toggleMockFolder(group.folder)">
          <mat-icon class="folder-arrow">{{ isMockFolderExpanded(group.folder) ? 'expand_more' : 'chevron_right' }}</mat-icon>
          <mat-icon class="folder-icon">folder</mat-icon>
          <span class="folder-name">{{ group.folder }}</span>
          <span class="folder-count">{{ group.items.length }}</span>
          <span class="folder-actions">
            <button class="header-btn" (click)="toggleMockFolder_enable(group.folder, $event)"
                    [title]="group.items.some(m => m.enabled) ? 'Disable all in folder' : 'Enable all in folder'">
              <mat-icon>{{ group.items.some(m => m.enabled) ? 'toggle_on' : 'toggle_off' }}</mat-icon>
            </button>
          </span>
        </div>
        @if (isMockFolderExpanded(group.folder)) {
          @for (mock of group.items; track mock.id) {
            <app-network-mock-row
              [entry]="mock"
              (duplicate)="duplicateMock($event)"
              (delete)="deleteMock($event)"
              (dragReorder)="onMockDragReorder($event)" />
          }
        }
      } @else {
        @for (mock of group.items; track mock.id) {
          <app-network-mock-row
            [entry]="mock"
            (duplicate)="duplicateMock($event)"
            (delete)="deleteMock($event)"
            (dragReorder)="onMockDragReorder($event)" />
        }
      }
    }
  }
</div>
